import { F0Alert } from '@factorialco/f0-react'

import { SyncIssue } from 'modules/integrations/hooks/SyncContext/issues'

const MAX_VISIBLE_NAMES = 4

type IssueItemProps = {
  issue: SyncIssue
}

export function formatAffectedNames(names: string[]): string {
  if (names.length === 0) return ''

  if (names.length <= MAX_VISIBLE_NAMES) {
    return names.join(', ')
  }

  const visible = names.slice(0, MAX_VISIBLE_NAMES)
  const remaining = names.length - MAX_VISIBLE_NAMES
  return `${visible.join(', ')} ...+${remaining}`
}

export function IssueItem({ issue }: IssueItemProps) {
  const affectedNamesText =
    issue.affectedNames && issue.affectedNames.length > 0
      ? formatAffectedNames(issue.affectedNames)
      : undefined

  return (
    <F0Alert
      variant="critical"
      title={issue.title}
      description={affectedNamesText ?? issue.description}
      action={
        issue.onAction && issue.buttonLabel
          ? { label: issue.buttonLabel, onClick: issue.onAction }
          : undefined
      }
      link={
        !issue.onAction && issue.buttonUrl && issue.buttonLabel
          ? { label: issue.buttonLabel, href: issue.buttonUrl }
          : undefined
      }
    />
  )
}
